interface HistoryState {
  // from react-router
  idx: number | undefined;
}

export const canGoBack =
  ((window.history.state as HistoryState | undefined)?.idx ?? 0) !== 0;
